module.exports = __webpack_public_path__ + "static/media/fb.181fe60c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Contact/components/Main/fb.svg
// module id = 113
// module chunks = 0